<template>
  <div class="toggle-input-container">
    <input type="checkbox" :id="uniqueId" v-model="toggled"/>
    <label :for="uniqueId">
      <div class="toggle-wrapper">
        <span :class="{'selected': !toggled}">{{offText}}</span>
        <span :class="{'selected': toggled}">{{onText}}</span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ToggleInput',
  props: {
    offText: {
      type: String,
      default: 'OFF',
    },
    onText: {
      type: String,
      default: 'ON',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    toggled: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    uniqueId() {
      return `checkbox-${this._uid}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/youpaired-colors.scss';

input[type="checkbox"] {
  display: none;
}

.toggle-wrapper {
  cursor: pointer;
  border: 1px solid #e4e4e4;
  width: 12rem;
  height: 2rem;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.toggle-wrapper > span {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  }

.selected {
  background-color: #e4e4e4;
  border-color: #e4e4e4;
  font-weight: 700;
}

.toggle-input-container {
  border: 1px solid #e4e4e4;
}
</style>
